<template>
	<div v-if="single" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:max-count="maxCount"
						:sl-attribute="false"
						:enable-copy-attribute-name="enableCopyAttributeName"
						:expression="expression"
						:locked-edit="lockedEdit"
						@recalculate="recalculateAttribute"
					/>
				</div>
				<div class="col-sm-7">
					<input type="text" :id="attributeName"
						   :class="'textInput attribute-editor ' + getDefaultValueWithLockClasses()"
						   v-model="attributeValue"
						   :disabled="lockedEdit">
					<button v-if="!lockedEdit" :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"></button>
				</div>
			</div>
		</div>
	</div>
	<div v-else data-attribute-type="single" :class="getColumnClass() + ' col-sm-7'">
		<div v-for="(value, key) in attributeValue" :key="key" :data-attribute-index="key">
			<div :class="SINGLE_ATTRIBUTE">
				<input type="text" :id="attributeName + '__' + key"
					   :class="'textInput attribute-editor multiple-hotkey ' + getDefaultValueWithLockClasses()"
					   v-model="attributeValue[key]"
					   :disabled="lockedEdit">
				<button v-if="!lockedEdit" :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"></button>
				<button v-if="!lockedEdit" class="button_minus fa fa-minus right-float-button" @click="deleteAttribute"
						tabindex="-1"></button>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import defaultClassManager from '../../mixins/defaultClassManager'
import { formatNumber } from 'utils/format'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { expressionCalculate } from '@/mixins/expressionCalculate'
import { UPDATE_ITEM_DATA } from 'actions/configurations'

export default {
	components: {
		AttributeLabel
	},
	mixins: [defaultClassManager, expressionCalculate],
	name: 'NAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'enableCopyAttributeName',
		'expression',
		'lockedEdit'
	],
	data () {
		return {
			single: !this.isMultiple,
			SINGLE_ATTRIBUTE: 'single-attribute',
      attributeValue: null
		}
	},
	computed: {
		itemData: function () {
			return this.$store.getters.getItemData
		}
	},
  watch: {
    attributeValue: function (newValue) {
      let val = Array.isArray(newValue) ? newValue : Number(newValue)
      this.$set(this.itemData, this.attributeName, val)
      this.$store.dispatch(UPDATE_ITEM_DATA, this.itemData).then(() => {})
    }
  },
	methods: {
		format: function (value) {
			if (value) {
				return formatNumber(String(value), this.$store.getters.getPerson)
			} else {
				return value
			}
		},
		deleteAttribute: function (e) {
			let key = $(e.target).parent().parent().attr('data-attribute-index')
			if (key > 0) {
				this.$delete(this.attributeValue, key)
				this.$set(this.itemData, this.attributeName, this.attributeValue)
				this.$nextTick(() => {
					attributeChangesRegister(this.attributeName)
				})
			}
		},
    getAttributeValue: function () {
      let vm = this
      let itemData = vm.itemData[vm.attributeName]
      let data = vm.defaultValue

      if (!itemData && vm.isMultiple) {
        return ['']
      }

      if (itemData === 0) {
        data = 0
      } else if (itemData) {
        data = itemData
      }
      if ((typeof data === 'undefined') || (data === null) || (data === 'NaN')) {
        return vm.single ? vm.format(vm.expressionCalculate()) : [vm.format(vm.expressionCalculate())]
      } else if (data === 0) {
        return 0
      } else if (Array.isArray(data) && data.length > 0) {
        return data.map(value => vm.format(value))
      } else {
        return this.format(data)
      }
    }
	},
  mounted () {
    this.attributeValue = this.getAttributeValue();
  }
}
</script>

<style scoped>

</style>
